import { createRouter, createWebHistory } from 'vue-router'
import Register from '../components/Register.vue'
import Login from '../components/Login.vue'
import TopPage from '../components/TopPage.vue'
import ShowDevice from '../components/ShowDevice.vue'

const routes = [
  { path: '/', component: TopPage },
  { path: '/register', component: Register },
  { path: '/login', component: Login },
  { path: '/top', component: TopPage },
  { path: '/showDevice/:devid', name: 'showDevice', component: ShowDevice, 
      state: { devicename: 'value'} }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

export default router
